<template>
  <div class="container">
    <div class="middlecontainer">
      <!-- <LeftMenu /> -->
      <OAuth2Login @loginResponse="onLoginResponse"/>
      <!-- <div> 
        <Campaigns />
      </div> -->
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import LeftMenu from './LeftMenu.vue'
import Campaigns from './Campaigns.vue'
import Login from './Login.vue'
import { mapMutations } from 'vuex'
import { 
    setCookie
    
} from '../services/campaignService';
import OAuth2Login from './OAuth2Login.vue'
export default {
  name: 'App',
  components: {
    Header,
    LeftMenu,
    Campaigns,
    Login,
    OAuth2Login
},
  methods: {
    onLoginResponse(data){
      if(data.code === 200){
        setCookie('token', data?.data.token, data?.data.expireTime)
        setCookie('userId', data?.data.userId, data?.data.expireTime)
        setCookie('role', data?.data?.role, data?.data.expireTime)
        this.$router.replace('/campaigns')
      }
    }
  }

}
</script>

<style scoped>
@font-face {
  font-family: "Inter-Regular";
  src: url('../assets/fonts/Inter-Regular.ttf');
}

.container {
  background: #F8F8F8;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.middlecontainer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
}



#app {

  font-family: "Inter-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
